
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "SunderlandClassificationOfNerveInjury",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SunderlandClassificationOfNerveInjury.vue